import { CwAdminTask, CwAdminWorkDay, CwAdminWorkDayDetail } from "../Interfaces"
import { Locale } from "../i18n"
import { roundHours } from "./jobSiteDailyHours"

export function adminTaskName(task: Pick<CwAdminTask, "nameEn" | "nameEs">, locale: Locale): string {
  if (locale === "es" && task.nameEs?.trim()) return task.nameEs.trim()
  return task.nameEn
}

export function detailTaskLabel(detail: CwAdminWorkDayDetail, locale: Locale, customLabel: string): string {
  if (detail.adminTask) return adminTaskName(detail.adminTask, locale)
  const custom = detail.customText?.trim()
  if (custom) return `${customLabel}: ${custom}`
  return customLabel
}

function ms(value: string | Date | null | undefined): number | null {
  if (!value) return null
  const n = new Date(value).getTime()
  return Number.isFinite(n) ? n : null
}

/** Hours for one segment; open segments run to `now` (capped at the day's end). */
export function segmentHours(
  detail: Pick<CwAdminWorkDayDetail, "startedAt" | "endedAt" | "hours">,
  dayEnd: string | Date | null | undefined,
  now: number,
): number {
  if (typeof detail.hours === "number" && detail.endedAt) return detail.hours
  const start = ms(detail.startedAt)
  if (start == null) return typeof detail.hours === "number" ? detail.hours : 0
  const end = ms(detail.endedAt) ?? ms(dayEnd) ?? now
  return Math.max(0, (end - start) / 3_600_000)
}

export function workDayHours(day: CwAdminWorkDay, now: number): number {
  const total = (day.details ?? []).reduce(
    (sum, d) => sum + segmentHours(d, day.clockedOutAt ?? day.autoEndedAt ?? null, now),
    0,
  )
  return roundHours(total)
}

export function sortTasks<T extends Pick<CwAdminTask, "sortOrder" | "nameEn" | "active">>(tasks: T[]): T[] {
  return [...tasks].sort((a, b) =>
    Number(b.active) - Number(a.active)
    || a.sortOrder - b.sortOrder
    || a.nameEn.localeCompare(b.nameEn))
}
